module.exports = __webpack_public_path__ + "img/logoSpore.b4006f3e.png";